(() => {
  "use strict";

  const SEEN_KEY = "pc_login_bubble_seen";
  const SHOW_DELAY = 1500;
  const DESKTOP_MQ = "(min-width: 1200px)";

  const isDesktop = () =>
    window.matchMedia && window.matchMedia(DESKTOP_MQ).matches;

  const seen = () => {
    try { return sessionStorage.getItem(SEEN_KEY) === "1"; }
    catch(e) { return false; }
  };

  const markSeen = () => {
    try { sessionStorage.setItem(SEEN_KEY, "1"); }
    catch(e) {}
  };

  const init = () => {
    if (!isDesktop()) return;
    if (seen()) return;

    const bubble = document.querySelector("[data-login-bubble]");
    if (!bubble) return;

    const closeBtn = bubble.querySelector("[data-login-bubble-close]");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        bubble.classList.remove("is-visible");
        bubble.setAttribute("aria-hidden", "true");
      }, { passive: true });
    }

    setTimeout(() => {
      if (!isDesktop()) return;
      if (seen()) return;

      bubble.classList.add("is-visible");
      bubble.setAttribute("aria-hidden", "false");

      markSeen();
    }, SHOW_DELAY);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();